/*
 * PMC shared DOM-mutation coordinator (staging perf optimisation)
 * ------------------------------------------------------------------
 * Replaces three independent full-document MutationObservers (one each
 * in pmc-payment-methods-global, pmc-enterprise-responsive-polish and
 * pmc-cart-drawer-polish) with ONE shared, debounced observer.
 *
 * It exposes window.pmcDom.subscribe(fn). Every subscriber is invoked
 * (debounced ~80ms, batched in a single rAF) whenever relevant DOM
 * mutations occur. Behaviour for each consumer is unchanged - they get
 * called on the same triggers - but the page now runs one observer
 * instead of three, and coalesces their callbacks into a single pass.
 */
(function () {
  if (window.pmcDom && window.pmcDom.subscribe) return;

  var subscribers = [];
  var scheduled = false;
  var debounceTimer = null;

  function runAll() {
    scheduled = false;
    for (var i = 0; i < subscribers.length; i++) {
      try {
        subscribers[i]();
      } catch (e) {
        /* one bad subscriber must never block the others */
      }
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(runAll);
    } else {
      window.setTimeout(runAll, 16);
    }
  }

  function debouncedSchedule() {
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(schedule, 80);
  }

  window.pmcDom = {
    subscribe: function (fn) {
      if (typeof fn !== 'function') return function () {};
      subscribers.push(fn);
      // Fire once on subscribe so consumers get their initial pass
      // regardless of when they registered relative to DOM readiness.
      schedule();
      return function unsubscribe() {
        var idx = subscribers.indexOf(fn);
        if (idx !== -1) subscribers.splice(idx, 1);
      };
    },
    // Allow consumers to request a pass on their own triggers
    // (cart events, clicks, etc.) without each owning an observer.
    ping: function () {
      schedule();
    }
  };

  // Wiser's global app embed currently emits two empty mount points with the
  // same IDs. Keep one canonical target and remove only redundant empty
  // mounts; populated app UI is preserved and simply loses the duplicate ID.
  window.pmcDom.subscribe(function dedupeKnownAppMountIds() {
    ['evmWiserWidegts', 'evm_quickViewModel'].forEach(function (id) {
      var nodes = Array.prototype.slice.call(document.querySelectorAll('[id="' + id + '"]'));
      nodes.slice(1).forEach(function (node) {
        if (!node.children.length && !(node.textContent || '').trim()) {
          node.remove();
        } else {
          node.removeAttribute('id');
        }
      });
    });
  });

  function startObserver() {
    if (window.pmcDom.__observing) return;
    window.pmcDom.__observing = true;

    var observer = new MutationObserver(debouncedSchedule);
    observer.observe(document.documentElement, { childList: true, subtree: true });

    // Shared, broadly-useful triggers so individual consumers can drop
    // their own listener sets where they only need "something changed".
    ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build', 'cart:rendered', 'shopify:section:load', 'variant:change', 'product:variant-change'].forEach(function (evt) {
      document.addEventListener(evt, schedule);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
